import { yupResolver } from "@hookform/resolvers/yup";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  FormControl,
  TextField,
  Typography,
} from "@mui/material";
import { useSnackbar } from "notistack";
import { not } from "ramda";
import React from "react";
import { type SubmitHandler, useForm } from "react-hook-form";
import * as yup from "yup";

import { Spacing } from "../types/enum";
import { AdminListPaginatedBannersDocument, useAdminCreateBannerMutation } from "../types/graphql";

/**
 * Types
 */
interface Props {
  open: boolean;
  onClose: () => void;
  limit: number;
  offset: number;
}

interface FormValues {
  title: string;
}
/**
 * Schema
 */
const schema = yup.object().shape({
  title: yup.string().required(),
});

const SlidersPageCreateCont: React.FC<Props> = ({ open, onClose, limit, offset }: Props) => {
  const { enqueueSnackbar } = useSnackbar();

  const { register, formState, handleSubmit } = useForm<FormValues>({
    mode: "all",
    resolver: yupResolver(schema),
  });

  const [createBanner, { loading }] = useAdminCreateBannerMutation({
    refetchQueries: [
      {
        query: AdminListPaginatedBannersDocument,
        variables: {
          filters: {
            limit,
            offset,
          },
        },
      },
    ],
  });

  const onSubmit: SubmitHandler<FormValues> = async (form) => {
    const variables = {
      input: {
        title: form.title,
      },
    };
    try {
      await createBanner({ variables });
      enqueueSnackbar("Banner successfully added", { variant: "success" });
      onClose();
    } catch (error: any) {
      enqueueSnackbar(error.message, { variant: "error" });
    }
  };

  return (
    <Dialog maxWidth="lg" open={open} onClose={onClose}>
      <form onSubmit={handleSubmit(onSubmit)}>
        <DialogContent>
          <Box mb={Spacing.sm}>
            <Typography variant="body1" color="textPrimary">
              Slider title
            </Typography>
            <Typography variant="body2" color="textSecondary">
              Please input the title of the slider that you would like to create.
            </Typography>
          </Box>
          <FormControl fullWidth>
            <TextField label="Title" variant="outlined" {...register("title")} />
          </FormControl>
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose}>Cancel</Button>
          <Button type="submit" disabled={not(formState.isValid) || loading}>
            Create
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
};

export default SlidersPageCreateCont;
